import React, { useEffect } from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import Flatpickr from "react-flatpickr";
import dateFormat from "dateformat";
import { useSelector } from "react-redux";
import store from "../../../../store/slices/commonSlice";
import {
  setDateValidError,
  setRendererFormState,
} from "../../../../store/slices/commonSlice";

const CustomDate = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
}) => {
  const dateError = useSelector(
    (state) => state.common.formRendererValidation.date
  );

  let key = databaseKey ? databaseKey : displayLabelKey;
  const isRequired = fieldEle?.["display-required"] === 1;

  const isInvalid = isRequired && !formState[key];
  const validationClass = isInvalid ? "is-invalid" : "is-valid";

  useEffect(() => {
    if (formState[key]) {
      store.dispatch(setDateValidError(false));
    }
  }, [formState, key]);

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className={`form-builder-element ${validationClass}`}
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <div className="input-group date">
          <Flatpickr
            // data-input
            style={{ width: "100%" }}
            options={{
              maxDate: new Date(),
              altInputClass: "hide",
              dateFormat: "M d Y",
              // minDate: new Date("01-01-2018"),
              wrap: true,
              appendTo: document.body,
              monthSelectorType: "dropdown",
              static: true,
            }}
            value={new Date(formState[key]|| "")}
            onChange={(e) =>
              store.dispatch(
                setRendererFormState({
                  key,
                  value: dateFormat(e[0], "yyyy-mm-dd hh:mm:ss"),
                })
              )
            }
          >
            <input
              type="text"
              className="form-control custom-datepicker mandatory"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              data-toggle
              placeholder={fieldEle?.["display-placeholder"]}
              data-input
              required={fieldEle?.["display-required"] === 1}
            />
          </Flatpickr>
          {dateError && (
            <div
              style={{
                fontSize: "0.875em",
                color: "#DC3545",
                marginTop: "0.25rem",
              }}
            >
              This field is required
            </div>
          )}
          {fieldEle?.["display-description"] && (
            <div className="form-text text-muted formElementDesc">
              {fieldEle?.["display-description"]}
            </div>
          )}
        </div>
      </div>
    </FormGroupWrapper>
  );
};

export default CustomDate;